(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('layoutGenerator', layoutGeneratorDirective)
    ;

    function layoutGeneratorDirective() {
        return {
            restrict: 'EA',
            scope: {
                content: '='
            },
            controller: layoutGeneratorDirectiveCtrl
        };
    }

    function layoutGeneratorDirectiveCtrl($scope, $element, $templateCache, $compile, Notifier, lodash, PanelRegistry) {
        var cloneElement = null,
            cloneScope = null;

        this.$onInit = function() {
            $scope.getColumnClass = getColumnClass;
            $scope.$on('$destroy', destroyElem);
            $scope.$watch("content", contentWatch);
        }

        function getColumnClass (column) {
            var classStr = column.class_name;
            if (!lodash.isNull(column.size)) {
                classStr = [classStr, 'small-12', 'medium-' + column.size].join(' ');
            }
            return classStr;
        }

        function destroyElem() {
            cloneElement.off();
        }

        function contentWatch() {
            var template = $templateCache.get("common/libraries/layoutBuilder/layout");

            if (template) {
                if (cloneElement) {
                    cloneScope.$destroy();
                    cloneScope = null;

                    cloneElement.off();
                    cloneElement.remove();
                    cloneElement = null;
                }

                PanelRegistry.clear();
                cloneScope = $scope.$new();

                var _html = angular.element(template);
                if (lodash.has($scope, 'content.directives')) {
                    angular.forEach($scope.content.directives, function (val) {
                        if (typeof val == 'string') {
                            _html.find('.lb-layout').attr(val, '');
                        } else {
                            _html.find('.lb-layout').attr(val[0], val[1]);
                        }

                    });
                }
                $element.html(_html);
                cloneElement = $compile($element.contents())(cloneScope);
            }

            Notifier.setLoading(false);
        }
    }
})();